import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ProductImage from "../../category/listings/ProductImage";
import { INVENTORY_STATES, SALE_STATES } from "../../../core/blocks/AdPlan/constants";
import type { ReactNode } from "react";
import type { TSelector } from "../../../../i18n/types";

interface Props {
  product: {
    id: string;
    sku: string;
    asin: string;
    sales_state: string;
    product_title: string;
    inventory_state: string;
  };
  showSalesLabelBadge?: boolean;
  showInventoryLabelBadge?: boolean;
  salesStateArray?: { value: string; label: TSelector }[];
  inventoryStateArray?: { value: string; label: TSelector }[];
  additionalBadges?: ReactNode;
  setSelectedProduct?: (value: string) => void;
  editBadge?: React.JSX.Element;
  showAsin?: boolean;
}

const ProductCell = ({
  product,
  showSalesLabelBadge,
  showInventoryLabelBadge = false,
  // Below allows for override to show more or less sales state badge options
  salesStateArray = [SALE_STATES.BEST_SELLER!, SALE_STATES.CLEARANCE!, SALE_STATES.NEW_PRODUCT!],
  inventoryStateArray = [INVENTORY_STATES.OVERSTOCK!, INVENTORY_STATES.LOW_STOCK!, INVENTORY_STATES.OUT_OF_STOCK!],
  additionalBadges = null,
  setSelectedProduct,
  editBadge,
  showAsin,
}: Props) => {
  const { t } = useTranslation(["merchandising", "advertising"]);
  const { id, sku, asin, sales_state, product_title, inventory_state } = product;
  const salesLabelSelector = salesStateArray.find((s) => s.value === sales_state)?.label;
  const inventoryBadgeSelector = inventoryStateArray.find((s) => s.value === inventory_state)?.label;
  const translatedSalesLabel = salesLabelSelector ? t(salesLabelSelector) : undefined;
  const translatedInventoryBadge = inventoryBadgeSelector ? t(inventoryBadgeSelector) : undefined;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        paddingRight: "3rem",
      }}
    >
      <div style={{ float: "left" }}>
        <ProductImage divId={"parentProductImage" + id} id={id} width="50px" height="50px" />
      </div>{" "}
      <div style={{ float: "left", width: "100%" }}>
        <div key={"parentProductAsin" + id}>
          <span
            style={{
              marginLeft: "1.5rem",
              fontSize: "15px",
              textAlign: "center",
              fontWeight: "500",
              cursor: "pointer",
              float: "left",
              color: typeof setSelectedProduct === "function" ? "#d91266" : "inherit",
              textDecoration: typeof setSelectedProduct === "function" ? "underline" : "none",
            }}
            onClick={() => setSelectedProduct && setSelectedProduct(id)}
          >
            {showAsin ? asin : sku} {editBadge}
          </span>
        </div>
        <div
          style={{
            float: "left",
            marginLeft: "1.5rem",
            fontSize: "1.25rem",
            width: "100%",
            textAlign: "left",
            whiteSpace: "break-spaces",
            fontWeight: 400,
            height: "100%",
          }}
        >
          {product_title}
        </div>
        {((showSalesLabelBadge && translatedSalesLabel) ||
          (showInventoryLabelBadge && translatedInventoryBadge) ||
          additionalBadges) && (
          <div
            style={{
              float: "left",
              marginLeft: "1.5rem",
              fontSize: "1.25rem",
              width: "100%",
              textAlign: "left",
              paddingTop: "1rem",
            }}
          >
            {showSalesLabelBadge && translatedSalesLabel && (
              <Badge className="badge-primary" pill>
                {translatedSalesLabel}
              </Badge>
            )}
            {showInventoryLabelBadge && translatedInventoryBadge && (
              <Badge className="badge-primary" style={{ marginLeft: "0.5rem", backgroundColor: "#c43066" }} pill>
                {translatedInventoryBadge}
              </Badge>
            )}
            {additionalBadges}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCell;
